import { useState } from "react";
import {ChevronDown} from 'lucide-react';

export interface FAQItem { q: string; a: string; }

function FAQ({ items, title = "Frequently asked questions" }: { items: FAQItem[]; title?: string }) {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section className="py-12 md:py-16">
      <div className="container-tight">
        <h2 className="text-3xl md:text-4xl font-semibold mb-8 text-slate-900">{title}</h2>
        <div className="divide-y divide-slate-200 border-t border-b border-slate-200">
          {items.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i}>
                <button
                  className="w-full flex items-start justify-between gap-6 text-left py-5 group"
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                >
                  <span className="font-serif text-lg font-semibold text-slate-900 group-hover:text-[#0A5FFF] transition-colors">{f.q}</span>
                  <ChevronDown
                    size={20}
                    className={`text-slate-400 mt-1 shrink-0 transition-transform ${isOpen ? "rotate-180 text-[#0A5FFF]" : ""}`}
                  />
                </button>
                {isOpen && (
                  <div className="pb-5 text-slate-600 leading-relaxed reveal">{f.a}</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
